import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";

Vue.use(Toast);
//创建axios实例对象
const  instance = axios.create({
    baseURL: '/api', // 本地开发走 vue 代理
    timeout: 5000, //默认超时时长
    withCredentials: true, 
})

//请求拦截器
instance.interceptors.request.use(config=>{
    if(config.method === "post"){
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
    }
    if(localStorage.getItem('token')){
        config.headers = {
            ...config.headers, 
            'token': Base64.encode(localStorage.getItem('token')),
            // 'lang': localStorage.getItem("lang").toLowerCase() || 'en_us'
            'lang': 'zh',
         
        }
    }
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    //此处对响应数据做处理
    if(res.data.msg === "鉴权错误"){
        // localStorage.clear();
        // this.$router.push({path:'/Login'})
    }
    return res //该返回对象会传到请求方法的响应对象中
},err=>{
    // 响应错误处理
    return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = unwrapApi(res.data)
        }).catch(()=>{
            result = { code: 500, msg: '服务异常，请稍后重试', data: {} }
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求
        await instance[option.method](
                api[option.url],
            qs.stringify(option.data)
        ).then(res=>{
            result = unwrapApi(res.data)
        }).catch(()=>{
            result = { code: 500, msg: '服务异常，请稍后重试', data: {} }
        })
    }
    return result
}

function unwrapApi(payload) {
    if (!payload || typeof payload !== 'object') {
        return { code: 500, msg: '服务异常，请稍后重试', data: {} }
    }
    try {
        if (payload.data) {
            payload.data = JSON.parse(Base64.decode(payload.data));
        }
    } catch (e) {
        payload.data = payload.data || {}
    }
    if (!payload.msg) {
        payload.msg = payload.code === 200 ? 'ok' : '操作失败'
    }
    return payload
}

export default http

